angular
    .module("accordionUploadDocumentsInstant.components", [])
    .component("accordionUploadDocumentsInstant", {
        templateUrl: "ng/components/accordionUploadDocumentsInstant/accordionUploadDocumentsInstant.view.html",
        bindings: {
            userDaCensire: "=",
            enabledSave: "&",
            instantModel: "<",
            isIntegration: "<",
            goBackModal: "&"
        },
        controllerAs: "uploadDocumentsInstantCtrl",
        controller: function accordionUploadDocuments(
            $configService,
            $rootScope,
            $timeout,
            $carouslService,
            $typeDomainService,
            Documento,
            $modalService,
            $scope,
            validationService,
            Pf,
            $instantService,
            $userService,
            $istatService,
            $download
        ) {
            var self = this;
            var onAfterCarouselChange = function (
                event,
                slick,
                currentSlide,
                nextSlide
            ) {
                if (self.lastIndex && self.lastIndex === currentSlide) {
                    return;
                }

                self.currentSlide = currentSlide;
                self.lastIndex = self.currentSlide;
                self.regExpDocumento = $carouslService.getDocumentType(
                    self.currentSlide
                );

                var tipoDocumento = $carouslService.getDocumentType(self.currentSlide);
                self.userDaCensire.documento.tipo = tipoDocumento;
                self.listaNomeRilascio = Documento.getEntiRilascio(tipoDocumento);

                //Se il numero di enti di rilascio è uguale a 1 lo valorizzo e rendo non editabile
                if (self.listaNomeRilascio.length < 2) {
                    self.userDaCensire.documento.enteRilascio.name = self.listaNomeRilascio[0].name;
                }
            };

            var initCarousel = function () {
                $timeout(function () {
                    $(".alba-document-for").slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: ".alba-document-carousel",
                        mobileFirst: true,
                        initialSlide: self.indexDocument
                    });

                    $(".alba-document-carousel").slick({
                        slideToShow: 3,
                        slideToScroll: 1,
                        centerMode: true,
                        asNavFor: ".alba-document-for",
                        focusOnSelect: true,
                        infinite: true,
                        variableWidth: true,
                        dots: true,
                        mobileFirst: true,
                        initialSlide: self.indexDocument
                    });

                    $(".alba-document-carousel").on("afterChange", onAfterCarouselChange);
                }, 500);
            };

            var getStati = function () {

                $istatService.getNazioni()
                    .then(function (response) {
                        self.listaNomiStatiNascita = response.domainList;

                        self.listaNomiStatiNascita = self.listaNomiStatiNascita.filter(
                            function (elem) {
                                return elem.name != "ITALIA";
                            }
                        );
                    });
            };

            self.$onInit = (function () {
                self.disabledFirmatarioTitolare = false;
                self.ilTransaction = 0;
                self.dealerUser = {};
                self.showLoader = false;
                self.base64 = null;
                self.link = "";
                self.progress = 0;
                self.frontBase64 = "";
                self.backBase64 = "";
                self.disabledInputCf = false;
                self.disabledInputDoc = false;
                self.mapComuni = $rootScope.comuniMap;
                self.currentCodeTypeNameIndex = 0;
                self.listaProvince = [];
                self.listaProvinceRilascio = [];
                self.listaNomeComuniRilascio = [];
                self.listaNomeComuniNascita = [];
                self.listaNomiStatiNascita = [];
                self.listaNomeComuniResidenza = [];
                self.listaCap = [];
                self.yesterday = moment().add(-1, "days").format("DD/MM/YYYY");
                self.today = moment().format("DD/MM/YYYY");
                self.tomorrow = moment()
                    .add(1, "days")
                    .format("DD/MM/YYYY");
                self.userDaCensire = self.userDaCensire | {};
                self.documentUpload = [{}];
                self.enabledModifyDocumentDate = false;
                self.currentSlide = 0;
                self.userDaCensire = {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                };
                Object.assign(self.userDaCensire, {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                });

                self.dropdown = {
                    ruolo: [],
                    stati: [],
                    comune: [],
                    statiEsteri: [],
                    entiRilascio: []
                };
                self.validationObj = {
                    documentDate: {
                        disabledDays: [0],
                        disabledDates: [
                            "01-01",
                            "06-01",
                            "25-04",
                            "01-05",
                            "02-06",
                            "15-08",
                            "01-11",
                            "08-12",
                            "25-12",
                            "26-12"
                        ]
                    },
                    regex: {
                        documentNumber: /.+/
                    }
                };

                //albaInit();
                getStati();

                self.onCarouselInit = function () {
                    console.log("carousel init");
                };

                self.listaProvince = self.mapComuni
                    .map(function (comune) {
                        return comune.sigla;
                    })
                    .filter(function (siglaComune) {
                        return siglaComune != "";
                    })
                    .sort()
                    .reduce(function (result, nextItem) {
                        return result.includes(nextItem) ? result : result.concat(nextItem);
                    }, []);

                self.listaProvince.push("EE");
                self.listaProvinceRilascio = self.listaProvince
                    .filter(function (elem) {
                        return elem != "EE"
                    });

                self.creaComuniRilascio = function (provincia) {
                    self.listaNomeComuniRilascio = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });

                    self.userDaCensire.documento.luogoEsteso = "";
                };

                self.creaComuniNascita = function (provincia) {
                    self.listaNomeComuniNascita = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });
                    self.userDaCensire.datiNascita.luogoEsteso = "";
                    self.verifyDate();
                };

                self.creaComuniResidenza = function (provincia, check) {
                    if (!check) {
                        self.userDaCensire.residenza.cap = "";
                        self.userDaCensire.residenza.indirizzo = "";
                        self.userDaCensire.residenza.numeroCivico = "";
                        self.userDaCensire.residenza.comune = "";
                        self.userDaCensire.residenza.luogoEsteso = "";
                        self.userDaCensire.residenza.stato = "";
                    }
                    if (provincia == "EE") {
                        self.isForeign = true;
                        return;
                    } else {
                        self.isForeign = false;
                    }
                    self.listaNomeComuniResidenza = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });


                };

                self.creaCap = function (comune, chiamataDalRest) {

                    if (!chiamataDalRest) {
                        self.userDaCensire.residenza.cap = "";
                    }

                    self.listaCap = comune.cap;
                };
                //getRuoli();
                $typeDomainService
                    .getRoles()
                    .then(function (response) {
                        self.dropdown.ruolo = response;
                    })
                    .catch(function (err) {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_NEXT"
                        });
                    });
                $timeout(function () {
                    self.userDaCensire = Pf.build(self.userDaCensire);
                    if (self.userDaCensire.documento.imgDocumentoCf) {
                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCf,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoFront,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoBack,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);
                        self.userDaCensire.isOk = false;

                        self.indexDocument =
                            $carouslService.getIndexByValue(
                                self.userDaCensire.documento.tipo
                            ) || 0;
                    }
                    if (self.userDaCensire.documento.tipo) {
                        self.enabledModifyDocumentDate = true;
                        self.regExpDocumento = self.userDaCensire.documento.tipo;
                    }
                    self.disabledUploadDocument();
                    initCarousel();
                    dealerUser();
                    self.ilTransaction = self.instantModel.appIlTransaction.id;
                    self.listaNomeRilascio = Documento.getEntiRilascio(
                        self.userDaCensire.documento.tipo
                    );
                    if (self.userDaCensire.residenza.luogoEsteso.nome == "") {

                        self.userDaCensire.residenza.luogoEsteso = "";

                    }
                    if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {

                        self.userDaCensire.datiNascita.luogoEsteso = "";

                    }
                    if (self.userDaCensire.documento.luogoEsteso.nome == "") {

                        self.userDaCensire.documento.luogoEsteso = "";
                    }
                    if (self.userDaCensire.residenza.luogoEsteso == "" && self.userDaCensire.residenza.provincia) {
                        self.creaComuniResidenza(self.userDaCensire.residenza.provincia);
                    }
                    if (self.userDaCensire.datiNascita.luogoEsteso == "" && self.userDaCensire.datiNascita.provincia) {
                        self.creaComuniNascita(self.userDaCensire.datiNascita.provincia);
                    }
                    if (self.userDaCensire.documento.luogoEsteso == "" && self.userDaCensire.documento.provincia) {
                        self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                    }

                }, 1);

                self.typePerson = $configService.getUser().type
                if (self.typePerson === 'ASSOCIATE_PERSON' || self.typePerson === 'SIGNER') {
                    self.disabeldPep = true;
                    self.disabledFirmatarioTitolare = true;
                    self.userDaCensire.titolare = {
                        pep: {
                            selected: "N"
                        }
                    }

                } else {
                    self.disabledFirmatarioIsCustomer = true;
                }
                self.linkPep = '/uni/download/service-infos/' + encodeURIComponent('GLOSSARIO') + '/';

                //RN:12378303
                self.userDaCensire.firmatario.spid = 'N';    

            })(
                (self.loadingStatus = {
                    uploading: false,
                    loadingDataFromCerved: false,
                    savedDataFromCerved: false,
                    loading: false,
                    loadingAddressesList: false,
                    loadingPfList: false,
                    insertingContract: false
                })
            );

            self.downloadInfoPep = () => {

                $download.getGenericDownload(self.linkPep)
                    .then(function (response) {
                        console.log(response);
                    })
            }

            self.deletePrivacyDocument = function (item, typeDocument) {
                //TODO
                //DA INTEGRARE IL PROCESSO DI CANCELLAZIONE DEI DOCUMENTI UNA VOLTA CHE MI ARRIVA LA RISPOSTA 
                //DAL SERVIZIO DEL MOBILE PER CAPIRE QUALI FILE SONO STATI CARICATI (ALMENO IL NOME)

                /*
                self.documentsToBeDeleted = self.documentUpload.filter(function (elem) {
                    return elem.selected == true;
                  });
                  self.documentsToBeDeleted.forEach(function (element) {
                    var type = 'PERSONAL_DOCUMENT'; //tipo di cancellazione es. IL – PERSONAL_DOCUMENT
                    var idObject = self.idNumber; // cf  oppure idWfInstance
                    var codiceDocNsil = 'F9F57B1B9DE5245527EE44BB85D3D4992236F1F7'; //es: 052
                    var fileName = element.name; //nome del file
          
                    $typeDomainService.deleteFile(type, idObject, codiceDocNsil, fileName)
                      .then(function (response) {
                        console.log(response);
                        self.documentUpload = self.documentUpload.filter(function (elem) {
                          return elem.selected != true;
                        })
                      })
                      .catch(function (error) {
                        $rootScope.$broadcast('addAlert', {
                          text: 'ERROR_TEC'
                        });
                      })
                      .finally(function () {
          
                        $timeout(function () {
                          self.visualProgBar = false;
                          self.uploadOk = false;
                        }, 4000);
                      })
                  });

                  */
                self.progresso = 100;
                if (typeDocument === 'imgCf') {
                    self.disabledInputCf = true;
                    $timeout(function () {
                        self.disabledInputCf = false;
                    }, 5000);
                } else {
                    self.disabledInputDoc = true;
                    $timeout(function () {
                        self.disabledInputDoc = false;
                    }, 5000);
                }
                $timeout(function () {
                    self.progresso = 0;
                }, 200);
                var documentRow =
                    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.selected != true;
                });
                //self.uploader.onCancelItem();
                if (typeDocument === "imgCf") {
                    self.userDaCensire.documento.imgDocumentoCf = "";
                } else {
                    //check front
                    var testFront = self.documentUpload.some(function (elem) {
                        return elem.name === self.userDaCensire.documento.imgDocumentoFront;
                    });
                    if (!testFront) {
                        self.userDaCensire.documento.imgDocumentoFront = "";
                    }

                    //check back
                    var testBack = self.documentUpload.some(function (elem) {
                        return elem.name === self.userDaCensire.documento.imgDocumentoBack;
                    });
                    if (!testBack) {
                        self.userDaCensire.documento.imgDocumentoBack = "";
                    }
                }
                self.disabledUploadDocument();

            };

            self.check = function (el) {
                el.selected = !el.selected;
                if (!self.userDaCensire.firmatario.selected) {
                    self.userDaCensire.firmatario.ruolo = "";
                    self.userDaCensire.email = "";
                } else if (!self.userDaCensire.titolare.selected) {
                    self.userDaCensire.titolare.pep = "No";
                }
            };

            self.generateDownloadLink = function (name) {
                console.log(name);
                return $configService.getUrl() +
                    "/uni/download/service-infos/" +
                    encodeURIComponent(self.userDaCensire.cf) +
                    "/F9F57B1B9DE5245527EE44BB85D3D4992236F1F7/" +
                    name +
                    "/PERSONAL_DOCUMENTS/?token=" +
                    $configService.getAppConfig().token;

                /*  $download.downloadFile(self.userDaCensire.cf, 'PERSONAL_DOCUMENTS', '', name)
                     .then(function (response) {
                         self.link = response;
                         console.log(response);
                         FileSaver.saveAs(response, name);


                     })
                 return self.link; */
            }

            self.enabledTrashRemovePdf = function () {
                return self.documentUpload.some(function (element) {
                    return element.selected === true;
                });
            };

            self.leastDocumentUpload = function () {
                var ritorno = false;

                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgDocument" && element.name;
                });
                return ritorno;
            };

            self.leastDocumentCfUpload = function () {
                var ritorno = false;
                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgCf";
                });
                return ritorno;
            };

            self.enteRilascioSelezionato = function (ente) {
                self.userDaCensire.documento.numero = "";
                if (ente === "MINISTERO") {
                    self.regExpDocumento = "UCO";
                } else if (ente === "DIPARTIM. TRASPORTI TERRESTI") {
                    self.regExpDocumento = "PAM";
                } else if (ente === "PREFETTURA") {
                    self.regExpDocumento = "PAT";
                }
                console.log(ente);
            };

            self.listaEntiRilascio = function (preserveData) {
                if (preserveData) {
                    return;
                }

                self.userDaCensire.documento.tipo = "";
                self.userDaCensire.documento.numero = "";
                self.userDaCensire.documento.luogo = "";
                self.userDaCensire.documento.provincia = "";
                self.userDaCensire.documento.dataRilascio = "";
                self.userDaCensire.documento.dataScadenza = "";
                self.userDaCensire.documento.imgDocumentoFront = "";
                self.userDaCensire.documento.imgDocumentoBack = "";
                self.userDaCensire.documento.enteRilascio.name = "";

                self.enabledModifyDocumentDate = true;
                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != "imgDocument";
                });
                self.disabledUploadDocument();
            };

            self.savePfData = function (pf) {
                console.log(pf);
                pf.isOk = true;
                self.modalShow = false;
                pf.documento.luogo = pf.documento.luogoEsteso.nome;
                pf.datiNascita.comune = pf.datiNascita.luogoEsteso.nome;
                pf.residenza.comune = pf.residenza.luogoEsteso.nome;
                pf = Pf.build(pf);
                self.enabledSave({
                    Pf: pf
                });
                $rootScope.$broadcast("pageLoader", {
                    action: "OPEN"
                });
            };
            self.undoDocumentChanges = function (pf) {
                if (self.isIntegration === true || self.validateForm()) {
                    pf.isOk = true;
                    $modalService.closeModal("censusPerson");
                    $(".financial-leasing__footer").css("z-index", "2");
                } else {
                    pf.isOk = false;
                    $modalService.closeModal("censusPerson");
                    $(".financial-leasing__footer").css("z-index", "2");
                    self.enabledSave({
                        Pf: pf
                    });
                }
                self.goBackModal && self.goBackModal();
            };

            self.getEndDate = function (dataRilascio) {
                if (dataRilascio) {
                    var tipoDocumento = self.userDaCensire.documento.tipo;
                    var dataNascita = self.userDaCensire.datiNascita.data;

                    if (dataRilascio) {
                        var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
                        var startYear = moment(dataRilascio).format("YYYY");
                        var startDay = moment(dataRilascio).format("DD");
                        var startMonth = moment(dataRilascio).format("MM");

                        var endDate = moment(dataRilascio)
                            .add(10, "years")
                            .format("DD/MM/YYYY");

                        //console.log("Data Scadenza Futura: " + moment(endDate).format('DD/MM/YYYY'));

                        if (
                            tipoDocumento === propMap["DOC_TYPE_CAI"] ||
                            tipoDocumento === propMap["DOC_TYPE_NCE"] ||
                            tipoDocumento === propMap["DOC_TYPE_CIE"] ||
                            tipoDocumento === propMap["DOC_TYPE_CAE"] ||
                            tipoDocumento === propMap["DOC_TYPE_PAT"]
                        ) {
                            var dataNascita = moment(dataNascita, "DD/MM/YYYY");
                            var birthYear = moment(dataNascita).format("YYYY");
                            var birthDay = moment(dataNascita).format("DD");
                            var birthMonth = moment(dataNascita).format("MM");

                            if (birthMonth == '02' && birthDay == '29') {
                                birthMonth = '03';
                                birthDay = '01';
                            }

                            var futureBirthDay = moment(
                                birthDay + "/" + birthMonth + "/" + startYear,
                                "DD/MM/YYYY"
                            )
                                .add(10, "years")
                                .format("DD/MM/YYYY");
                            //console.log("Compleanno Futuro: " + futureBirthDay);

                            var daysDiff = moment
                                .duration(
                                    moment(endDate, "DD/MM/YYYY").diff(
                                        moment(futureBirthDay, "DD/MM/YYYY")
                                    )
                                )
                                .asDays();

                            var expiryDate;
                            if (daysDiff <= 0) {
                                expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
                                    "DD/MM/YYYY"
                                );
                            } else {
                                expiryDate = moment(
                                    birthDay + "/" + birthMonth + "/" + startYear,
                                    "DD/MM/YYYY"
                                )
                                    .add(11, "years")
                                    .format("DD/MM/YYYY");
                            }
                            while (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) {
                                expiryDate = moment(
                                    expiryDate,
                                    "DD/MM/YYYY"
                                )
                                    .add(10, "years")
                                    .format("DD/MM/YYYY");
                            }

                            if (
                                moment
                                    .duration(
                                        moment(
                                            self.userDaCensire.documento.dataScadenza,
                                            "DD/MM/YYYY"
                                        ).diff(moment(expiryDate, "DD/MM/YYYY"))
                                    )
                                    .asDays() > 0
                            ) {
                                $scope.pfForm.dataScadenza.$valid = false;
                            }
                            return expiryDate;
                        } else {
                            if (
                                moment
                                    .duration(
                                        moment(
                                            self.userDaCensire.documento.dataScadenza,
                                            "DD/MM/YYYY"
                                        ).diff(moment(endDate, "DD/MM/YYYY"))
                                    )
                                    .asDays() > 0
                            ) {
                                $scope.pfForm.dataScadenza.$valid = false;
                            }
                            return endDate;
                        }
                    } else {
                        return moment(self.today, "DD/MM/YYYY")
                            .add(10, "years")
                            .format("DD/MM/YYYY");
                    }
                }
                return moment(self.today, "DD/MM/YYYY")
                    .add(10, "years")
                    .format("DD/MM/YYYY");
            };

            self.validateForm = function () {
                var checkUploadFound = false;
                if (
                    self.userDaCensire &&
                    self.userDaCensire.documento &&
                    self.userDaCensire.documento.imgDocumentoCf &&
                    self.userDaCensire.documento.imgDocumentoFront &&
                    self.userDaCensire.documento.imgDocumentoBack
                ) {
                    checkUploadFound =
                        self.userDaCensire.documento.imgDocumentoCf &&
                        self.userDaCensire.documento.imgDocumentoFront &&
                        self.userDaCensire.documento.imgDocumentoBack;
                }
                var check = self.userDaCensire.firmatario.selected;
                if (self.userDaCensire.residenza.provincia != "EE") {
                    if (check) {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.firmatario.ruolo &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.documentiCaricati &&
                            self.userDaCensire.titolare.pep != 'Y' &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.documentiCaricati &&
                            self.userDaCensire.titolare.pep != 'Y' &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    }
                } else {
                    if (check) {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.firmatario.ruolo &&
                            self.userDaCensire.documentiCaricati &&
                            self.userDaCensire.datiNascita.stato &&
                            self.userDaCensire.titolare.pep != 'Y' &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.documentiCaricati &&
                            self.userDaCensire.datiNascita.stato &&
                            self.userDaCensire.titolare.pep != 'Y' &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    }
                }

            };

            self.getTodaysDate = function () {
                return moment().format("DD/MM/YYYY");
            };


            self.verifyDate = function () {
                self.testDati = true;
                var codCat;
                if (self.userDaCensire && self.userDaCensire.datiNascita &&
                    self.userDaCensire.datiNascita.luogoEsteso &&
                    self.userDaCensire.datiNascita.luogoEsteso.nome) {
                    codCat = self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale;
                } else if (self.userDaCensire && self.userDaCensire.datiNascita && self.userDaCensire.datiNascita.stato.name) {
                    codCat = self.userDaCensire.datiNascita.stato.value;
                }
                if (!codCat) {
                    self.testDati = false;
                    return;
                }

                self.testDati = validationService.checkCfWithFieds(
                    self.userDaCensire.cf,
                    self.userDaCensire.nome,
                    self.userDaCensire.cognome,
                    self.userDaCensire.datiNascita.data,
                    self.userDaCensire.sesso,
                    codCat
                );

                if (!self.testDati) {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", false);
                    }
                } else {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", true);
                    }
                }


            };

            self.disabledUploadDocument = function () {
                if (self.uploadDocumenti === "imgCf") {
                    self.uploadCfCompleted = false;
                } else {
                    self.uploadDocCompleted = false;
                    self.frontBase64 = "";
                    self.backBase64 = "";
                }
                self.disabledUploadCf = self.documentUpload.some(function (elem) {
                    return elem.type === "imgCf";
                });

                var temp = 0;

                self.documentUpload.forEach(function (elem) {
                    if (elem.type === "imgDocument") {
                        temp++;
                    }

                    if (temp >= 2) {
                        self.disabledUploadDocIdent = true;
                    } else {
                        self.disabledUploadDocIdent = false;
                    }
                });
            };

            var dealerUser = function () {

                $userService.getDealerUser()
                    .then(function (dealer) {
                        if (dealer) {
                            self.dealerUser = dealer;
                        }
                    });
            }

            self.startUploadDocument = function () {
                $rootScope.$broadcast("pageLoader", {
                    action: "OPEN"
                });

                var person = {
                    cf: self.dealerUser.identifier,
                    nome: self.dealerUser.name.toUpperCase(),
                    cognome: self.dealerUser.surname.toUpperCase(),
                    telefono: self.dealerUser.tel,
                    documento: {
                        tipo: self.userDaCensire.documento.tipo
                    }
                }

                var inputStartMobileCapture = {
                    persons: [
                        Pf.build(person)
                    ],
                    appIlTransaction: {
                        id: self.ilTransaction
                    },
                    flagCallFE: 'false'
                };
                self.intervalOfRepeatListenMobileCapture = 0;
                var numberOfIteration = 0;
                $instantService.startMobileCapture(inputStartMobileCapture)
                    .then(function (response) {
                        if (response.success) {

                            var inputListenMobileCapture = {
                                id: response.id
                            };

                            self.intervalOfRepeatListenMobileCapture = setInterval(function () {
                                $instantService.listenMobileCapture(inputListenMobileCapture)
                                    .then(function (response) {
                                        numberOfIteration++;
                                        if (response.success && response.details.uploadCompleted) {
                                            clearInterval(self.intervalOfRepeatListenMobileCapture);
                                            $rootScope.$broadcast("pageLoader", {
                                                action: "CLOSE"
                                            });
                                            response.ocrResponse.cf = self.userDaCensire.cf;
                                            response.ocrResponse.nome = self.userDaCensire.nome == "" ? response.ocrResponse.nome : self.userDaCensire.nome;
                                            response.ocrResponse.cognome = self.userDaCensire.cognome == "" ? response.ocrResponse.cognome : self.userDaCensire.cognome;
                                            response.ocrResponse.sesso = self.userDaCensire.sesso;
                                            response.ocrResponse.documento.enteRilascio = self.userDaCensire.documento.enteRilascio;
                                            response.ocrResponse.documento.tipo = self.userDaCensire.documento.tipo;
                                            response.ocrResponse.datiNascita = self.userDaCensire.datiNascita;
                                            response.ocrResponse.firmatario = self.userDaCensire.firmatario;
                                            response.ocrResponse.titolare = self.userDaCensire.titolare;

                                            var luogoDocumento = self.mapComuni.filter(function (element) {
                                                return element.nome.toUpperCase() == response.ocrResponse.documento.luogo && response.ocrResponse.documento.luogo.toUpperCase()
                                            });
                                            response.ocrResponse.documento.luogoEsteso = luogoDocumento[0];
                                            response.ocrResponse.documento.provincia = luogoDocumento[0] && luogoDocumento[0].sigla;

                                            var luogoResidenza = self.mapComuni.filter(function (element) {
                                                return element.nome.toUpperCase() == response.ocrResponse.residenza.comune && response.ocrResponse.residenza.comune.toUpperCase();
                                            });
                                            response.ocrResponse.residenza.luogoEsteso = luogoResidenza[0];
                                            response.ocrResponse.residenza.provincia = luogoResidenza[0] && luogoResidenza[0].sigla;
                                            response.ocrResponse.residenza.indirizzo = response.ocrResponse.residenza.indirizzo;
                                            response.ocrResponse.residenza.numeroCivico = response.ocrResponse.residenza.numeroCivico;
                                            self.userDaCensire = Pf.build(response.ocrResponse);
                                            self.userDaCensire.documentiCaricati = true;
                                            self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                                            self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                                            if (self.userDaCensire.residenza.luogoEsteso.nome == "") {

                                                self.userDaCensire.residenza.luogoEsteso = "";

                                            }
                                            if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {

                                                self.userDaCensire.datiNascita.luogoEsteso = "";

                                            }
                                            if (self.userDaCensire.documento.luogoEsteso.nome == "") {

                                                self.userDaCensire.documento.luogoEsteso = "";
                                            }

                                            //aggiunto scroll a sezione successiva quando il rest termina con successo 
                                            //il valore di 730 è un magic number
                                            $('#mCSB_5_container').animate({
                                                'top': '-730px'
                                            }, 800);
                                        }
                                        if (numberOfIteration >= 50) {
                                            $rootScope.$broadcast("pageLoader", {
                                                action: "CLOSE"
                                            });

                                            $rootScope.$broadcast("addAlert", {
                                                text: 'ERROR_TIMEOUT_LISTEN_MOBILE'
                                            });

                                            clearInterval(self.intervalOfRepeatListenMobileCapture);


                                        }
                                        console.log('Numero di iterazioni', numberOfIteration);
                                    })
                                    .catch(function (error) {
                                        console.log(error);

                                        $rootScope.$broadcast("pageLoader", {
                                            action: "CLOSE"
                                        });
                                    })


                            }, 10000);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.showLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                        });
                    })
                    .finally(function () {

                    });
            }

            self.$onDestroy = function () {
                clearInterval(self.intervalOfRepeatListenMobileCapture);

                $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE"
                });
            }

        }
    });